import React from 'react';
import {ToggleButton, ToggleButtonGroup} from '@mui/material';
import {BsList, BsMap} from 'react-icons/bs';

interface SearchMapListToggleProps {
  isMapActive: boolean;
  onToggle: () => void;
}

const SLATE = '#324559';

/**
 * List / Map switch beside the search box. Below lg the map replaces the list, so this is the
 * way between them; it stays in view over the map, and is the way back to the list and its
 * request-a-space form when the area has no yards (securspace-ui#3095). At lg and up the
 * list and map show side by side, so it hides.
 */
const SearchMapListToggle = ({isMapActive, onToggle}: SearchMapListToggleProps) => (
  <ToggleButtonGroup
    exclusive
    value={isMapActive ? 'map' : 'list'}
    onChange={(_, view: string | null) => view && (view === 'map') !== isMapActive && onToggle()}
    aria-label="Results view"
    sx={{
      display: {xs: 'flex', lg: 'none'},
      flexShrink: 0,
      p: '2px',
      border: 1,
      borderColor: 'divider',
      borderRadius: 999,
      '& .MuiToggleButtonGroup-grouped, & .MuiToggleButtonGroup-grouped:not(:first-of-type), & .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
        m: 0,
        border: 'none',
        borderRadius: 999,
      },
      '& .MuiToggleButton-root': {
        height: 38,
        px: 1.25,
        gap: 0.5,
        color: SLATE,
        // px, not pxToRem: the theme converts against a 16px root but the app's is 14px, so
        // pxToRem(13) came out 11.4px. 14px matches the filter chips under it.
        fontSize: '14px',
        fontWeight: 500,
        textTransform: 'none',
      },
      '& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover': {
        bgcolor: SLATE,
        color: 'white',
      },
    }}
  >
    <ToggleButton value="list"><BsList size={16}/>List</ToggleButton>
    <ToggleButton value="map"><BsMap size={16}/>Map</ToggleButton>
  </ToggleButtonGroup>
);

export default SearchMapListToggle;
